import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.div`
	color: ${helpers.color.textSubtitle};
`
